import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { LanguageProvider } from "@/context/LanguageContext";
import { AuthProvider } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";

import PublicLayout from "@/components/PublicLayout";
import Home from "@/pages/Home";
import Apartments from "@/pages/Apartments";
import ApartmentDetail from "@/pages/ApartmentDetail";
import Contact from "@/pages/Contact";
import FAQ from "@/pages/FAQ";
import GuestGuide from "@/pages/GuestGuide";
import { Privacy, CookiePolicy } from "@/pages/Legal";
import CheckIn from "@/pages/CheckIn";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminAnalytics from "@/pages/admin/AdminAnalytics";
import AdminApartments from "@/pages/admin/AdminApartments";
import AdminBookings from "@/pages/admin/AdminBookings";
import AdminCheckins from "@/pages/admin/AdminCheckins";
import AdminReviews from "@/pages/admin/AdminReviews";
import AdminOTA from "@/pages/admin/AdminOTA";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminLogs from "@/pages/admin/AdminLogs";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <AuthProvider>
          <SettingsProvider>
            <BrowserRouter>
              <Toaster position="top-center" richColors closeButton />
              <Routes>
                <Route element={<PublicLayout />}>
                  <Route path="/" element={<Home />} />
                  <Route path="/apartments" element={<Apartments />} />
                  <Route path="/apartments/:id" element={<ApartmentDetail />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/faq" element={<FAQ />} />
                  <Route path="/guide" element={<GuestGuide />} />
                  <Route path="/privacy" element={<Privacy />} />
                  <Route path="/cookie-policy" element={<CookiePolicy />} />
                </Route>

                <Route path="/checkin/:token" element={<CheckIn />} />

                <Route path="/admin" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminLayout />}>
                  <Route path="dashboard" element={<AdminDashboard />} />
                  <Route path="analytics" element={<AdminAnalytics />} />
                  <Route path="apartments" element={<AdminApartments />} />
                  <Route path="bookings" element={<AdminBookings />} />
                  <Route path="checkins" element={<AdminCheckins />} />
                  <Route path="reviews" element={<AdminReviews />} />
                  <Route path="ota" element={<AdminOTA />} />
                  <Route path="settings" element={<AdminSettings />} />
                  <Route path="logs" element={<AdminLogs />} />
                </Route>

                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </BrowserRouter>
          </SettingsProvider>
        </AuthProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
